/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getEtsyInfoPacks = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Etsy Info Pack query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-etsy-info-pack/get?${queryString}`);
};

export const getEtsyInfoPackByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-etsy-info-pack/${id}`);
};

export const getEtsyInfoPackByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-etsy-info-pack/mid/${mid}`);
};

export const searchEtsyInfoPacks = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Etsy Info Pack search query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-etsy-info-pack/search?${queryString}`);
};

export const createEtsyInfoPack = (etsyInfoPackData) => {
  return API.post(`${getApiUrl()}/api/tkt1-etsy-info-pack/`, etsyInfoPackData);
};

export const updateEtsyInfoPack = (id, etsyInfoPackData) => {
  return API.put(`${getApiUrl()}/api/tkt1-etsy-info-pack/${id}`, etsyInfoPackData);
};

export const deleteEtsyInfoPack = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-etsy-info-pack/${id}`);
};

export const tkt1EtsyInfoPackService = {
  getEtsyInfoPacks,
  getEtsyInfoPackByID,
  getEtsyInfoPackByMID,
  searchEtsyInfoPacks,
  createEtsyInfoPack,
  updateEtsyInfoPack,
  deleteEtsyInfoPack
};
